(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1222],{

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 66370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImagesGalleryComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _images_gallery_row_images_gallery_row_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99112);







var ImagesGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ImagesGalleryComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ImagesGalleryComponent);
    function ImagesGalleryComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ImagesGalleryComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ImagesGalleryComponent, [
        {
            key: "convertToMatrixIfNeeded",
            value: function convertToMatrixIfNeeded(assets) {
                if (assets && !Array.isArray(assets[0])) {
                    return [
                        assets
                    ];
                }
                return assets;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, assets = _props.assets, shadow = _props.shadow, screenRatios = _props.screenRatios, grayscale = _props.grayscale, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                assets = this.convertToMatrixIfNeeded(assets);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "images-gallery",
                    children: assets.map(function(assetsRow, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_gallery_row_images_gallery_row_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            grayscale: grayscale,
                            assets: assetsRow,
                            shadow: shadow,
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }, index);
                    })
                });
            }
        }
    ]);
    return ImagesGalleryComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

ImagesGalleryComponent.defaultProps = {
    assets: [],
    grayscale: false
};


/***/ }),

/***/ 49281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _logos_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83971);

/* harmony default export */ __webpack_exports__["Z"] = ({
    numberOfCompanies: _logos_const__WEBPACK_IMPORTED_MODULE_0__/* .NUMBER_OF_COMPANIES */ .X$,
    grayscale: false,
    showAllLogos: false,
    companyField: _logos_const__WEBPACK_IMPORTED_MODULE_0__/* .LOGO_COMPANY_FIELDS.GENERAL */ .QS.GENERAL,
    logosScale: 1,
    useSingleLine: false,
    paddingInlined: "0px"
});


/***/ }),

/***/ 89206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos-const.js
var logos_const = __webpack_require__(83971);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/default-props.js
var default_props = __webpack_require__(49281);
// EXTERNAL MODULE: ./components/core/images-gallery/images-gallery-component.js
var images_gallery_component = __webpack_require__(66370);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/logos/logos.scss.js


var LOGO_BIG_SCREEN_WIDTH = 150;
var LOGO_SMALL_SCREEN_WIDTH = 120;
var LOGO_SLIM_WIDTH = 72;
var LOGO_SLIM_HEIGHT = 35;
var LOGO_WIDTH_TOTAL_PADDING = 32;
var LOGO_BIG_SCREEN_HEIGHT = 69;
var LOGO_SMALL_SCREEN_HEIGHT = 50;
var StyledLogos = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egj6ol80"
})("margin:auto;display:flex;justify-content:center;max-width:", function(props) {
    return props.maxWidth;
}, ";.image-gallery{transform:scale(", function(props) {
    return props.logosScale;
}, ");}.images-logos-wrapper{width:100%;}.images-gallery-row{display:flex;justify-content:center;flex-wrap:", function(props) {
    return props.useSingleLine ? "nowrap" : "wrap";
}, ";padding-inline:", function(props) {
    return props.paddingInlined;
}, ";.image-gallery{padding:24px 0;display:flex;justify-content:center;width:244px;.social-proof-gallery-picture{img{max-height:", LOGO_BIG_SCREEN_HEIGHT, "px;max-width:", LOGO_BIG_SCREEN_WIDTH - LOGO_WIDTH_TOTAL_PADDING, "px;}}}}&.slim.slim{.images-gallery-row{justify-content:flex-start;gap:32px;.image-gallery{padding:8px 0;width:auto;.social-proof-gallery-picture{img{max-height:", LOGO_SLIM_HEIGHT, "px;max-width:", LOGO_SLIM_WIDTH, "px;}}}}}&.new-layout{@media (max-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){max-width:", vp_sizes.XS, "px;}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) and (min-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){.images-logos-wrapper{.images-gallery{.images-gallery-row{.image-gallery{max-width:120px;.social-proof-gallery-picture{img{max-height:56px;max-width:96px;}}}}}}}.images-gallery-row{.image-gallery{width:", LOGO_BIG_SCREEN_WIDTH, "px;}}}@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){&:not(.new-layout){.images-gallery-row{.image-gallery{padding:12px 0;margin:0 20px;width:170px;}}}&.slim.slim{.images-gallery-row{gap:24px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){:not(.new-layout),.new-layout{margin-top:16px;.images-gallery-row{padding:0;.image-gallery{width:", LOGO_SMALL_SCREEN_WIDTH, "px;margin:0;padding:0 0 25px 0;.social-proof-gallery-picture{img{max-height:", LOGO_SMALL_SCREEN_HEIGHT, "px;max-width:", LOGO_SMALL_SCREEN_WIDTH - LOGO_WIDTH_TOTAL_PADDING, "px;}}}}.slim.slim{.images-logos-wrapper{max-width:300px;.images-gallery-row{.image-gallery{margin:0;width:unset;.social-proof-gallery-picture{img{max-height:48px;max-width:92px;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/logos/logos.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var Logos = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Logos, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Logos);
    function Logos(props) {
        (0,_class_call_check/* default */.Z)(this, Logos);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "isNewLayout", function() {
            return _this.getNumberOfCompaniesToDisplay() == logos_const/* NUMBER_OF_COMPANIES */.X$; // compare string and int (old props can be integers)
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getNumberOfCompaniesToDisplay", function() {
            var numberOfCompanies = _this.props.numberOfCompanies;
            if (logos_const/* SUPPORTED_LOGOS_NUMBER_OPTIONS.includes */.ly.includes(numberOfCompanies === null || numberOfCompanies === void 0 ? void 0 : numberOfCompanies.toString())) return numberOfCompanies;
            return logos_const/* NUMBER_OF_COMPANIES */.X$; // support old pages config which had companyNummber = 3, 8  + use this as the default prop when numberOfCompanies isn't defined
        });
        _this.state = {
            mobileView: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Logos, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (window.matchMedia(vp_sizes/* MOBILE_QUERY */.lF).matches) {
                    this.setState({
                        mobileView: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, grayscale = _props.grayscale, showAllLogos = _props.showAllLogos, companyField = _props.companyField, country = _props.country, slim = _props.slim, personalizeUsingVisitorCountry = _props.personalizeUsingVisitorCountry, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, abTests = _props.abTests, logosScale = _props.logosScale, useSingleLine = _props.useSingleLine, paddingInlined = _props.paddingInlined, maxWidth = _props.maxWidth;
                var assets = (0,logos_const/* getCompaniesAssets */.yA)({
                    companyField: companyField,
                    country: country,
                    personalizeUsingVisitorCountry: personalizeUsingVisitorCountry,
                    cloudfrontViewerCountry: cloudfrontViewerCountry,
                    abTests: abTests
                });
                var numberOfCompaniesToDisplay = this.getNumberOfCompaniesToDisplay();
                var companiesAssetsSliced = showAllLogos ? assets : assets.slice(0, numberOfCompaniesToDisplay);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogos, {
                    className: classnames_default()("logos", {
                        "full-logo-list": showAllLogos,
                        "new-layout": this.isNewLayout(),
                        slim: slim
                    }),
                    logosScale: logosScale,
                    useSingleLine: useSingleLine,
                    paddingInlined: paddingInlined,
                    maxWidth: maxWidth,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "images-logos-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_component/* default */.Z, {
                            grayscale: grayscale,
                            assets: companiesAssetsSliced,
                            shouldTrackMouseEvents: true
                        })
                    })
                });
            }
        }
    ]);
    return Logos;
}(react.PureComponent);
Logos.defaultProps = default_props/* default */.Z;
/* harmony default export */ var logos = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Logos)));


/***/ }),

/***/ 53294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LogosTitleComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/logos/components/logos-title/logos-title-component.scss.js
var componentStyles = new String(".logos-title-component.jsx-aa1747c6318d2e78{padding:0 32px;text-align:center}");
componentStyles.__hash = "aa1747c6318d2e78";

// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/logos/components/logos-title/default-props.js

/* harmony default export */ var default_props = ({
    title: "Trusted by <monday-paying-companies />+ customers worldwide",
    titleSize: sizes.SM,
    padding: "0 32px",
    textAlign: "center"
});

;// CONCATENATED MODULE: ./segments/desktop/logos/components/logos-title/logos-title-component.js










var LogosTitleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LogosTitleComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LogosTitleComponent);
    function LogosTitleComponent() {
        (0,_class_call_check/* default */.Z)(this, LogosTitleComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LogosTitleComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, titleSize = _props.titleSize, textAlign = _props.textAlign, padding = _props.padding;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: textAlign,
                        padding: padding
                    },
                    className: "jsx-".concat(componentStyles.__hash) + " " + "logos-title-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                            title: title,
                            titleSize: titleSize
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return LogosTitleComponent;
}(react.PureComponent);

LogosTitleComponent.defaultProps = default_props;


/***/ }),

/***/ 36238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TopLogosComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/logos-title-component.js + 2 modules
var logos_title_component = __webpack_require__(53294);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos.js + 1 modules
var logos_logos = __webpack_require__(89206);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-component.scss.js


var StyledTopLogosComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yzksec0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;");

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var TopLogosComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopLogosComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopLogosComponent);
    function TopLogosComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, TopLogosComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getTitleStyle", function() {
            var _props = _this.props, textAndLogosMargin = _props.textAndLogosMargin, titleColor = _props.titleColor;
            return _object_spread({}, titleColor && {
                color: colors/* default */.Z[titleColor]
            }, textAndLogosMargin && {
                marginBottom: textAndLogosMargin
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(TopLogosComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, titleSize = _props.titleSize, logos = _props.logos, logosAdvancedProps = _props.logosAdvancedProps;
                var titleStyle = this.getTitleStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopLogosComponent, {
                    className: "top-logos-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "logosTitleWrapper",
                            style: titleStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_title_component/* default */.Z, {
                                title: title,
                                titleSize: titleSize
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_logos/* default */.Z, _object_spread({}, logos, logosAdvancedProps))
                    ]
                });
            }
        }
    ]);
    return TopLogosComponent;
}(react.PureComponent);

TopLogosComponent.defaultProps = _object_spread_props(_object_spread({}, logos_title_component/* default.defaultProps */.Z.defaultProps), {
    logos: logos_logos/* default.defaultProps */.Z.defaultProps,
    paddingTop: "68px",
    paddingBottom: "68px",
    mobilePaddingTop: "24px",
    mobilePaddingBottom: "24px",
    textAndLogosMargin: "24px"
});


/***/ })

}]);